module.exports = __webpack_public_path__ + "img/regpack-inactive.c37ec2b9.svg";